module.exports = __webpack_public_path__ + "static/media/face5.d2417284.jpg";